import script from "./Item.vue?vue&type=script&setup=true&lang=js"
export * from "./Item.vue?vue&type=script&setup=true&lang=js"

import "./Item.vue?vue&type=style&index=0&id=5a424465&lang=scss&scoped=true"
script.__scopeId = "data-v-5a424465"

export default script